import React from "react";
import PageHeader from "../components/PageHeader";
import ServicesGrid from "../components/ServicesGrid";
import ContactCTA from "../components/ContactCTA";
import { ApproachSection, AccreditationBar } from "../components/Sections";

const ServicesPage = () => (
  <>
    <PageHeader
      title="ISO Consulting & Certification Services"
      subtitle="End-to-end consulting for every major ISO standard   from gap analysis and documentation to internal audits and final certification support."
      crumbs={[{ label: "Services" }]}
    />
    <ServicesGrid />
    <ApproachSection />
    <AccreditationBar />
    <ContactCTA />
  </>
);

export default ServicesPage;
